import { PAGE_TYPE_KEY_NAMES } from 'detailsv2/LandingV2/Page/types';

import { EPageType } from './types';
export { PAGE_TYPE_KEY_NAMES };

const DEFAULT_TYPE_OPTIONS = [
  { label: PAGE_TYPE_KEY_NAMES[EPageType.ACTIVITY], value: EPageType.ACTIVITY },
  { label: PAGE_TYPE_KEY_NAMES[EPageType.AREA], value: EPageType.AREA },
  { label: PAGE_TYPE_KEY_NAMES[EPageType.MISC], value: EPageType.MISC },
  { label: PAGE_TYPE_KEY_NAMES[EPageType.ABOUT_US], value: EPageType.ABOUT_US },
  { label: PAGE_TYPE_KEY_NAMES[EPageType.ABOUT_SAFARI], value: EPageType.ABOUT_SAFARI },
  { label: PAGE_TYPE_KEY_NAMES[EPageType.PRE_TRAVEL_INFO], value: EPageType.PRE_TRAVEL_INFO },
];

const PRIMARY_TYPE_OPTIONS = [
  { label: PAGE_TYPE_KEY_NAMES[EPageType.AREA], value: EPageType.AREA },
  { label: PAGE_TYPE_KEY_NAMES[EPageType.MISC], value: EPageType.MISC },
  { label: PAGE_TYPE_KEY_NAMES[EPageType.ABOUT_SAFARI], value: EPageType.ABOUT_SAFARI },
  { label: PAGE_TYPE_KEY_NAMES[EPageType.PRE_TRAVEL_INFO], value: EPageType.PRE_TRAVEL_INFO },
];

const SECONDARY_TYPE_OPTIONS = [
  { label: PAGE_TYPE_KEY_NAMES[EPageType.PROPERTY], value: EPageType.PROPERTY },
  { label: PAGE_TYPE_KEY_NAMES[EPageType.MISC], value: EPageType.MISC },
];

const PROPERTY_TYPE_OPTIONS = [{ label: PAGE_TYPE_KEY_NAMES[EPageType.PROPERTY], value: EPageType.PROPERTY }];

const AREA_TYPE_OPTIONS = [{ label: PAGE_TYPE_KEY_NAMES[EPageType.AREA], value: EPageType.AREA }];

export const TYPE_OPTIONS = {
  default: DEFAULT_TYPE_OPTIONS,
  primary: PRIMARY_TYPE_OPTIONS,
  secondary: SECONDARY_TYPE_OPTIONS,
  property: PROPERTY_TYPE_OPTIONS,
  area: AREA_TYPE_OPTIONS,
};
